/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FeeOption
 */
export interface FeeOption {
    /**
     * Stable id of this fee option within its entry, server-assigned when absent. Referenced by the charge flow (feeId).
     * @type {string}
     * @memberof FeeOption
     */
    id?: string;
    /**
     * Display label, e.g. Standard, Staff, Member. Free text — patient-facing behaviour is driven by patient_facing, never by label matching.
     * @type {string}
     * @memberof FeeOption
     */
    label: string;
    /**
     * Charge amount. Server-clamped to 0..10000.
     * @type {number}
     * @memberof FeeOption
     */
    amount: number;
    /**
     * True when this is the price a patient may be quoted (e.g. by the AI assistant's generated pricing sections) and the default charge. Non-patient-facing fees (staff rates) are never surfaced to patients, and their label is appended to the Stripe charge description.
     * @type {boolean}
     * @memberof FeeOption
     */
    patient_facing?: boolean;
}

/**
 * Check if a given object implements the FeeOption interface.
 */
export function instanceOfFeeOption(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "amount" in value;

    return isInstance;
}

export function FeeOptionFromJSON(json: any): FeeOption {
    return FeeOptionFromJSONTyped(json, false);
}

export function FeeOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeeOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'label': json['label'],
        'amount': json['amount'],
        'patient_facing': !exists(json, 'patient_facing') ? undefined : json['patient_facing'],
    };
}

export function FeeOptionToJSON(value?: FeeOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'label': value.label,
        'amount': value.amount,
        'patient_facing': value.patient_facing,
    };
}

